import { DataSource } from "../../analytics/enums";
import { Filter } from "../../analytics/ui/types";

export const BillingRuleStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
} as const;

export type BillingRuleStatus =
  (typeof BillingRuleStatus)[keyof typeof BillingRuleStatus];

export const BillingRuleType = {
  ADJUST_TO_LIST: "ADJUST_TO_LIST",
  APPLY_MARGIN: "APPLY_MARGIN",
  BACKOUT_LINE_ITEM: "BACKOUT_LINE_ITEM",
  REALLOCATE_COSTS: "REALLOCATE_COSTS",
  RERATE: "RERATE",
  MOVE_BILLING_ACCOUNT: "MOVE_BILLING_ACCOUNT", // Unused for now.
  RECURRING_CHARGE: "RECURRING_CHARGE", // Unused for now.
} as const;

export type BillingRuleType =
  (typeof BillingRuleType)[keyof typeof BillingRuleType];

export const ReallocationType = {
  DYNAMIC: "DYNAMIC",
  STATIC: "STATIC",
} as const;

export type ReallocationType =
  (typeof ReallocationType)[keyof typeof ReallocationType];

type Identifier = {
  labels: Record<string, string>;
  subAccountID: string;
};

export type StaticReallocationTarget = {
  identifier: Identifier;
  share: number;
};

// Unused for now.
export type DynamicReallocationTarget = {
  identifier: Identifier;
  sourceMatchValues: Record<string, string | null>;
};

export type ReallocationConfigDynamic = {
  type: typeof ReallocationType.DYNAMIC;
  dataSource: DataSource;
  filters?: Filter[];
  measure: string;
  minimumShare: number;
  usageGroupingDimensions: string[];
};

export type ReallocationConfigStatic = {
  type: typeof ReallocationType.STATIC;
  targets: StaticReallocationTarget[];
};

export type ReallocationTypeConfig =
  | ReallocationConfigDynamic
  | ReallocationConfigStatic;

export type RuleMeta = {
  adjustToList?: boolean;
  filters?: Filter[];
  metrics?: string[];
  reallocationConfig?: ReallocationTypeConfig;
  value?: number;
};

export type BillingRuleEntity = {
  id: string;
  tenantID: string;
  createdAt: string;
  createdByID: string;
  updatedAt: string | null;
  updatedByID: string | null;
  applyToAllTenants: boolean;
  applyToTenantIDs: string[];
  endTime: string | null;
  isLegacy: boolean; // TODO: Remove this once CUC is no longer supported
  name: string;
  priority: number;
  startTime: string;
  status: BillingRuleStatus;
  type: BillingRuleType;
  meta: RuleMeta;
};
